import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Show a success notification
export const showSuccessNotification = (message) => {
  toast.success(message, {
    autoClose: 3000,
    theme: "colored",
    closeOnClick: true,
    pauseOnHover: true,
  });
};

// Show an error notification
export const showErrorNotification = (message) => {
  toast.error(message, {
    autoClose: 3000,
    theme: "colored",
    closeOnClick: true,
    pauseOnHover: true,
  });
};
// Show an info notification
export const showInfoNotification = (message) => {
    toast.info(message, {
      autoClose: 3000,
      theme: "colored",
      closeOnClick: true,
      pauseOnHover: true,
    });
  };
  // Show an warn notification
export const showWarnNotification = (message) => {
    toast.error(message, {
      autoClose: 3000,
      theme: "colored",
      closeOnClick: true,
      pauseOnHover: true,
    });
  };

  export const ToastNotificationContainer = () => <ToastContainer />;